import {RouterModule, Routes} from '@angular/router';
import {AppComponent} from './app.component';
import {NotFoundComponent} from './pages/shared/components/errors-handling/not-found/not-found.component';
// import {DashboardComponent} from './dashboard/dashboard.component';

export const appComponents = [
    AppComponent
];
const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),
    },
    {
        path: '**',
        component: NotFoundComponent,
        pathMatch: 'full',
    },
];

export const appRoutes = RouterModule.forRoot(routes);
